import { init, setTag } from '@sentry/react';

declare global {
  interface Window {
    // Per-instance Sentry context injected at runtime by the Blade shell
    // (config('sentry.environment') / config('app.site') / config('app.instance')).
    // The bundle is shared across instances/environments, so these CANNOT be baked
    // — they arrive here at runtime.
    sentryEnvironment?: string | null;
    sentrySite?: string | null;
    sentryInstance?: string | null;
  }
}

const readWindow = (value: unknown): string | undefined =>
  typeof value === 'string' && value !== '' ? value : undefined;

const dns =
  (
    import.meta.env.VITE_SENTRY_REACT_DSN as
      | string
      | number
      | boolean
      | null
      | undefined
  )?.toString() ?? '';

const hasWindow = typeof window !== 'undefined';
const environment = hasWindow
  ? readWindow(window.sentryEnvironment)
  : undefined;
const site = hasWindow ? readWindow(window.sentrySite) : undefined;
const instance = hasWindow ? readWindow(window.sentryInstance) : undefined;

if (dns.length > 0 && dns !== 'TODO') {
  init({
    dsn: dns,
    environment,
    // `release` is injected automatically by @sentry/vite-plugin (release.name in
    // vite.config) → @sentry/browser picks it up at init, no need to set it here.
    tunnel: 'https://stry-tunnel.tecnobit.it/tunnel',
    // NOTE: @sentry/* v11 removed the `sendDefaultPii` flag (PII is sent by
    // default); `true` was already our setting, so behavior is unchanged.
  });

  // Explicit tags so the single project can be filtered per code-variant (site)
  // and per deployment (instance), independent of `environment`.
  if (site) setTag('site', site);
  if (instance) setTag('instance', instance);
}
